import React, { createContext, useContext, ReactNode } from 'react';
import { HttpClient } from './HttpClient';

interface HttpClientContextType {
  httpClientCore: HttpClient;
  httpClientIntegration: HttpClient;
}

const HttpClientContext = createContext<HttpClientContextType | undefined>(undefined);

interface HttpClientProviderProps {
  children: ReactNode;
  httpClientCore: HttpClient;
  httpClientIntegration: HttpClient;
}

export const HttpClientProvider: React.FC<HttpClientProviderProps> = ({ children, httpClientCore, httpClientIntegration }) => {
  return <HttpClientContext.Provider value={{ httpClientCore, httpClientIntegration }}>{children}</HttpClientContext.Provider>;
};

export const useHttpClientCore = (): HttpClient => {
  const context = useContext(HttpClientContext);
  if (context === undefined) {
    throw new Error('useHttpClientCore must be used within a HttpClientProvider');
  }
  return context.httpClientCore;
};

export const useHttpClientIntegration = (): HttpClient => {
  const context = useContext(HttpClientContext);
  if (context === undefined) {
    throw new Error('useHttpClientIntegration must be used within a HttpClientProvider');
  }
  return context.httpClientIntegration;
};
